import React, { FC, useEffect, useState } from 'react';
import Icon from '../../../../../@shared/icon';
import { iconSize } from '../../../../../../constants/icon.constants';
import { TCardProps } from '../../../../types/dealerLocator.types';

const radioButtondefault = 'action-radio-default';
const radioButtonChecked = 'action-radio-checked';

const Card: FC<TCardProps> = (props: TCardProps) => {

    const [iconName, updateIconName] = useState<string>(radioButtondefault);
    const { dealerNumber,
        dealerName,
        selectedDealerNumber,
        updateSelectedDealerNumber,
        shippingAddress,
        shippingCity,
        shippingZip,
        shippingPhone,
        isLarge,
        distanceUnit,
        shippingStateProv
     } = props;
    const distance = Number.parseFloat(props?.distance ?? '');
    const distanceText = !Number.isNaN(distance) ? `${(Math.round(distance * 100) / 100).toFixed(2)} ${distanceUnit}` : '';
    
    useEffect(() => {
        if (selectedDealerNumber === dealerNumber) {
            updateIconName(radioButtonChecked);
        } else {
            updateIconName(radioButtondefault);
        }
    }, [selectedDealerNumber]);

    return (
        // eslint-disable-next-line
        <div className={`preferred-dealer-card ${isLarge ? 'preferred-dealer-card--large' : ''}`} key={dealerNumber}  onClick={() => updateSelectedDealerNumber && updateSelectedDealerNumber(dealerNumber)} >
            <div><Icon iconName={iconName} size={iconSize['dsk']} /></div>
            <div className='preferred-dealer-card__details'>
                <p className='preferred-dealer-card__name'>{dealerName}</p>
                <span>
                    <p>{distanceText}</p>
                    <p>{shippingAddress}</p>
                    <p>{shippingCity}, {shippingStateProv || ''} {shippingZip}</p>
                    <p>{shippingPhone}</p>
                </span>
            </div>
        </div>
    )
}

export default Card;
